import setUserNoteData from './setUserNoteData';
import saveUserNoteService from '../services/saveUserNoteService';
import removeUserMarkupPopupEventListener from '../utils/removeUserMarkupPopupEventListener';
import { ClientItem } from 'owa-mail-store';
import UserNote from 'owa-mail-store/lib/store/schema/UserNote';
import parseMarkId from 'owa-mark/lib/utils/parseMarkId';
import unmarkElements from 'owa-mark/lib/utils/unmarkElements';
import { action, orchestrator } from 'satcheljs';

const removeUserNote = action(
    'removeUserNote',
    (
        element: HTMLElement,
        item: ClientItem,
        keyword: string,
        instance: number,
        content: string
    ) => ({
        element: element,
        item: item,
        keyword: keyword,
        instance: instance,
        content: content,
    })
);

orchestrator(removeUserNote, actionMessage => {
    const { element, item, keyword, instance, content } = actionMessage;

    let itemNotes: UserNote[] = item.userNoteData ? item.userNoteData.slice() : [];
    let indexOfNote = -1;
    if (itemNotes) {
        for (let i = 0; i < itemNotes.length; i++) {
            const note = itemNotes[i];
            if (note.keyword == keyword && note.instance == instance && note.content == content) {
                indexOfNote = i;
                break;
            }
        }
    }
    if (indexOfNote > -1) {
        itemNotes.splice(indexOfNote, 1);

        // Remove user note from local store
        setUserNoteData(item, itemNotes);

        // Remove user note from server
        saveUserNoteService(item.ItemId.Id, itemNotes);

        // Remove user note from DOM
        const noteId = parseMarkId(element.className);
        unmarkElements(noteId, removeUserMarkupPopupEventListener);
    }
});

export default removeUserNote;
